import {http, onSuccess, onFail} from './http';

export const twitterGet = (eventKey, data) =>
    http.get(`/api/player/event/${eventKey}/twitter`, data)
        .then(onSuccess, onFail);
